import Vue from 'vue';
import Vuex from 'vuex';
import { mapGetters } from 'vuex'

Vue.use(Vuex);

import { items } from '@/assets/items.json';
import Factory from '@/Factory';

export const store = new Vuex.Store({
  state: {
    brick: "",
    items: items,
    bingo: false,
    shareStr: ""
  },
  mutations: {

    init: (state, params) => {
      store.commit('loadBrick',params);
    },

    saveBrick: (state, params) => {
      if (typeof(Storage) !== "undefined") {
        sessionStorage.setItem("brick", JSON.stringify(state.brick));
      }
    },

    loadBrick: (state, params) => {

      let stored = false;

      if (typeof(Storage) !== "undefined") {
        let brick = sessionStorage.getItem("brick");
        if(brick){
          stored = true;
          state.brick = JSON.parse(brick);
          store.commit('unsetBingo');
          store.commit('generateShareString',params);
        }
      }

      if(!stored){
        store.commit('generateBrick',params);
      }

    },

    generateBrick: (state, params) => {

      state.bingo = false;
      state.brick = Factory.Brick(params.size);

      console.log(state.brick)

      for(var i = 0; i < state.brick.size; i++){
        let newLength = state.brick.rows.push(Factory.BrickRow(state.brick.size));
        let row = state.brick.rows[newLength-1];
        state.brick.bingoRows.push(false);
        state.brick.bingoCols.push(false);
        for(var j = 0; j < state.brick.size; j++){
          let id = Math.floor(Math.random() * state.items.length);
          row.items.push(Factory.BrickItem(state.items[id],false,id));
        }
      }

      store.commit('generateShareString',params);
      store.commit('saveBrick');

    },

    generateBrickFromQuery: (state, params) => {

      state.bingo = false;

      let itemIds = params.b.split(",");
      let size = Math.sqrt(itemIds.length);
      state.brick = Factory.Brick(size);

      let item = 0;
      for(var i = 0; i < state.brick.size; i++){
        let newLength = state.brick.rows.push(Factory.BrickRow(state.brick.size));
        let row = state.brick.rows[newLength-1];
        state.brick.bingoRows.push(false);
        state.brick.bingoCols.push(false);
        for(var j = 0; j < state.brick.size; j++){
          let id = itemIds[item];
          let checked = false;
          if(id.indexOf("x") != -1){
            checked = true;
            id = id.slice(0, -1);
          }
          row.items.push(Factory.BrickItem(state.items[id],checked,id));
          item++;
        }
      }
      store.commit('generateShareString');
      store.commit('saveBrick');
    },

    toggleBrickItem: (state, {item}) => {
      item.checked = !item.checked;
      if(!item.checked){
        item.bingo = false;
      }
      store.commit('testBingo');

      store.commit('generateShareString');
      store.commit('saveBrick');
    },

    testBingo: (state,params) => {
      state.bingo = false;

      //Test row bingo
      for(var i = 0; i < state.brick.size; i++){
        let checked = state.brick.rows[i].items.filter(item => item.checked)
        if(checked.length == state.brick.size){
          if(state.brick.bingoRows[i] == false){
            state.bingo = true;
            for(var col = 0; col < state.brick.size; col++){
              state.brick.rows[i].items[col].bingo = true;
            }
          }
          state.brick.bingoRows[i] = true;

        }
        else if(state.brick.bingoRows[i] == true){
          state.brick.bingoRows[i] = false;
        }
      }

      //Test col bingo
      for(var i = 0; i < state.brick.size; i++){
        let checked = state.brick.rows.filter(row => row.items[i].checked)
        if(checked.length == state.brick.size){
          if(state.brick.bingoCols[i] == false){
            state.bingo = true;
            for(var row = 0; row < state.brick.size; row++){
              state.brick.rows[row].items[i].bingo = true;
            }
          }
          state.brick.bingoCols[i] = true;

        }
        else if(state.brick.bingoCols[i] == true){
          state.brick.bingoCols[i] = false;
        }
      }

    },

    unsetBingo: (state,params) => {
      state.bingo = false;

      for(var i = 0; i < state.brick.size; i++){
        for(var j = 0; j < state.brick.size; j++){
          state.brick.rows[i].items[j].bingo = false;
        }
      }

    },

    generateShareString: (state,params) => {
      state.shareStr = "";
      for(var i = 0; i < state.brick.size; i++){
        for(var j = 0; j < state.brick.size; j++){
          state.shareStr += state.brick.rows[i].items[j].id;
          if(state.brick.rows[i].items[j].checked){
            state.shareStr += "x";
          }
          state.shareStr += ",";
        }
      }
      state.shareStr = state.shareStr.slice(0, -1);
    },

  },
  getters: {

    getRandomItem: state => {
      return Math.floor(Math.random() * state.items.length);
    }

  },
});



// WEBPACK FOOTER //
// ./src/store.js